// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Mint from 'mint-ui';
import Vant from 'vant';
import 'vant/lib/index.css';
import Es6Promise from 'es6-promise';
import router from './router'
import Store from './store/index';
import axios from 'axios';
import { priceFilter, sexFilter, jsTimestampFilter, stateFilter, orderStatusFilter, payTypeFilter, scoreFilter, salaryFilter, educationFilter, jobExperiencesFilter, jobTypeFilter } from '@/utils/filters';
import App from './App';
import { getMD5 } from '@/utils/md5';
import Navigator from '@/components/Navigator';
import ErrorMsg from '@/components/ErrorMsg';
import CustomForm from '@/components/CustomForm';
import ServiceRate from '@/components/ServiceRate';
import QrcodeQuickEntry from '@/components/QrcodeQuickEntry';
import FastClick from 'fastclick';
import taUrl from '@/static/backstageUrl';
import '../src/static/flexible.js';

import 'mint-ui/lib/style.css';
import '@/static/my-mint.scss';
import '@/static/reset.css';
import '@/static/site.css'
import '@/static/font/iconfont.css';

Es6Promise.polyfill();

Vue.component('Navigator', Navigator);
Vue.component('ErrorMsg', ErrorMsg);
Vue.component('CustomForm', CustomForm);
Vue.component('ServiceRate', ServiceRate);
Vue.component('QrcodeQuickEntry', QrcodeQuickEntry);

Vue.prototype.$http = axios;
axios.defaults.headers['clientType'] = '5';
axios.defaults.headers['version'] = '1.0';
// axios.defaults.headers['token'] = Store.state.token;
axios.defaults.headers['auth'] = '4f7087695bc9025846ccfdb39495f109';
axios.interceptors.response.use(function (response) {
  // token过期错误码
  if (response.data.resCode === '10004' || response.data.resCode === '10009' || response.data.resCode === '10010'){
    Store.commit('change_token', '');
    root.$root.eventHub.$emit('login', root.$route.fullPath);
  }
  return response
}, function (error) {
  // Do something with response error
  return Promise.reject(error)
})

Vue.prototype.URL_PREFIX = '';
if (process.env.NODE_ENV !== 'development') {
  Vue.prototype.URL_PREFIX = taUrl.apiUrl;
}

Vue.prototype.URL_PREFIX_PAGE = taUrl.wxUrl;

Vue.prototype.MD5 = function MD5(value) {
  return getMD5(value);
};

Vue.filter('SexState', sexFilter);
Vue.filter('PriceFilter', priceFilter);
Vue.filter('DateFilter', jsTimestampFilter);
Vue.filter('stateFilter', stateFilter);
Vue.filter('orderStatusFilter', orderStatusFilter);
Vue.filter('payTypeFilter', payTypeFilter);
Vue.filter('scoreFilter', scoreFilter);
Vue.filter('salaryFilter', salaryFilter);
Vue.filter('educationFilter', educationFilter);
Vue.filter('jobExperiencesFilter', jobExperiencesFilter);
Vue.filter('jobTypeFilter', jobTypeFilter);

Vue.use(Mint);
Vue.use(Vant);

FastClick.attach(document.body);

Vue.config.productionTip = false;

/* eslint-disable no-new */
const root = new Vue({
  el: '#app',
  router,
  store: Store,
  render: h => h(App),
  data: {
    eventHub: new Vue(),
  },
})
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    var _hmt = _hmt || [];
    (function() {
     //每次执行前，先移除上次插入的代码
     document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
     var hm = document.createElement("script");
     hm.src = "https://hm.baidu.com/hm.js?6143f9d6fd22a5fb27872975d01b2133";
     hm.id = "baidu_tj"
     var s = document.getElementsByTagName("script")[0];
     s.parentNode.insertBefore(hm, s);
    })();
  },0);
 } );




// WEBPACK FOOTER //
// ./src/main.js